// This file was generated by a custom prisma generator, do not edit manually.
/* eslint-disable ts/no-redeclare */
export const MerloExtensions = {
  ZM1: 'ZM1',
  ZM2: 'ZM2',
  ZM3: 'ZM3',
} as const

export type MerloExtensions = (typeof MerloExtensions)[keyof typeof MerloExtensions]

export const MachineryUVVReportItemType = {
  LiftingMechanismGeneral: 'LiftingMechanismGeneral',
  GeneralForks: 'GeneralForks',
  ThicknessAtForkBend: 'ThicknessAtForkBend',
  PermanentDeformation: 'PermanentDeformation',
  CracksAtBendAndSuspension: 'CracksAtBendAndSuspension',
  LengthOverAtLeast6Divisions: 'LengthOverAtLeast6Divisions',
  ExhaustInspectionForDieselEngines: 'ExhaustInspectionForDieselEngines',
  ServiceBrakeBrakeLine: 'ServiceBrakeBrakeLine',
  ParkingBrakeBrakingPerformance: 'ParkingBrakeBrakingPerformance',
  BrakeOnDrawbar: 'BrakeOnDrawbar',
  BrakeSystem: 'BrakeSystem',
  WheelsAndTires: 'WheelsAndTires',
  DriverRestraintSystem: 'DriverRestraintSystem',
  SeatAttachment: 'SeatAttachment',
  SteeringSystem: 'SteeringSystem',
  ControlsAndLabeling: 'ControlsAndLabeling',
  BatteryCondition: 'BatteryCondition',
  BatteryMounting: 'BatteryMounting',
  BatteryData: 'BatteryData',
  SeatSwitchOrShutOffDevice: 'SeatSwitchOrShutOffDevice',
  EmergencyStopSwitch: 'EmergencyStopSwitch',
  SafetyDisconnectSwitch: 'SafetyDisconnectSwitch',
  ElectricalWiring: 'ElectricalWiring',
  SafetySwitchOnDrawbar: 'SafetySwitchOnDrawbar',
  LiftSystemLoweringTest: 'LiftSystemLoweringTest',
  TiltSystemCreepTest: 'TiltSystemCreepTest',
  LeaksAndDamages: 'LeaksAndDamages',
  AttachmentPoints: 'AttachmentPoints',
  FrameAndSafetyEquipment: 'FrameAndSafetyEquipment',
  TrailerCoupling: 'TrailerCoupling',
  FloorOpeningsForLpgForklifts: 'FloorOpeningsForLpgForklifts',
  HoodLocking: 'HoodLocking',
  Signage: 'Signage',
  OperatingManual: 'OperatingManual',
  Attachments: 'Attachments',
  AdditionalEquipment: 'AdditionalEquipment',
  InspectionBook: 'InspectionBook',
  LastProtocol: 'LastProtocol',
  TypePlateOrCEMarking: 'TypePlateOrCEMarking',
  WarningOrInformationSign: 'WarningOrInformationSign',
  ElectricalTestDGUVV3: 'ElectricalTestDGUVV3',
  ElectricalBox: 'ElectricalBox',
  HydraulicFluidLevel: 'HydraulicFluidLevel',
  HydraulicHosesCondition: 'HydraulicHosesCondition',
  HydraulicHosesAge: 'HydraulicHosesAge',
  HydraulicSystemTightness: 'HydraulicSystemTightness',
  RemoteControlCondition: 'RemoteControlCondition',
  RemoteControlLabeling: 'RemoteControlLabeling',
  RemoteControlFunction: 'RemoteControlFunction',
  CabinCondition: 'CabinCondition',
  CabinSeat: 'CabinSeat',
  CabinControl: 'CabinControl',
  WheelsCondition: 'WheelsCondition',
  WheelsConfirmation: 'WheelsConfirmation',
  EndSwitch: 'EndSwitch',
  LoadAssessment: 'LoadAssessment',
  DamageToSheetMetalEtc: 'DamageToSheetMetalEtc',
  BrakeFunction: 'BrakeFunction',
  AccessoryMainHook: 'AccessoryMainHook',
  AccessoryMechanicalJIB: 'AccessoryMechanicalJIB',
  AccessoryHydraulicJIB: 'AccessoryHydraulicJIB',
  AccessoryRopeWinch: 'AccessoryRopeWinch',
  AccessoryFork: 'AccessoryFork',
  RadiusControlValueMin: 'RadiusControlValueMin',
  RadiusControlValueMax: 'RadiusControlValueMax',
  OverloadWithR: 'OverloadWithR',
  Miscellaneous: 'Miscellaneous',
  RiskAssessment: 'RiskAssessment',
  DeclarationOfConformity: 'DeclarationOfConformity',
  LicensePlate: 'LicensePlate',
  ABEVehicleRegistrationDocument: 'ABEVehicleRegistrationDocument',
  FirstAidKitOrWarningTriangle: 'FirstAidKitOrWarningTriangle',
  WarningLight: 'WarningLight',
  Tools: 'Tools',
  FrameBoltBearing: 'FrameBoltBearing',
  FairingMudguard: 'FairingMudguard',
  StepHandleAscent: 'StepHandleAscent',
  Rotator: 'Rotator',
  TransportLock: 'TransportLock',
  Counterweight: 'Counterweight',
  TowingEquipment: 'TowingEquipment',
  LashingLiftingPoint: 'LashingLiftingPoint',
  WheelChock: 'WheelChock',
  WheelTireRims: 'WheelTireRims',
  Gearbox: 'Gearbox',
  AxlesAndSuspension: 'AxlesAndSuspension',
  SteeringKnuckleAndTieRods: 'SteeringKnuckleAndTieRods',
  CardanShafts: 'CardanShafts',
  TractionMotorAndTractionDrive: 'TractionMotorAndTractionDrive',
  MachineSupport: 'MachineSupport',
  MachineSupportPlate: 'MachineSupportPlate',
  MachineSupportBasePlate: 'MachineSupportBasePlate',
  BrakeLine: 'BrakeLine',
  BrakePedal: 'BrakePedal',
  BrakingEffect: 'BrakingEffect',
  BrakeCableLinkages: 'BrakeCableLinkages',
  BrakeBooster: 'BrakeBooster',
  OilTankFilter: 'OilTankFilter',
  HydraulicConnections: 'HydraulicConnections',
  HydraulicControlBlocks: 'HydraulicControlBlocks',
  HydraulicPump: 'HydraulicPump',
  HydraulicCylinders: 'HydraulicCylinders',
  PressureReliefValves: 'PressureReliefValves',
  StarterAndLighting: 'StarterAndLighting',
  BatteryAndFuse: 'BatteryAndFuse',
  CableAndConnection: 'CableAndConnection',
  SwitchAndDistributionBox: 'SwitchAndDistributionBox',
  IndicatorLight: 'IndicatorLight',
  IgnitionLockAndKeySwitch: 'IgnitionLockAndKeySwitch',
  TiltSensor: 'TiltSensor',
  WarningDevices: 'WarningDevices',
  EmergencyDrain: 'EmergencyDrain',
  LMBOverloadDevice: 'LMBOverloadDevice',
  EngineMounting: 'EngineMounting',
  EngineStartStop: 'EngineStartStop',
  EngineStarterInterlock: 'EngineStarterInterlock',
  SpeedControl: 'SpeedControl',
  VBelt: 'VBelt',
  OilFuelLevel: 'OilFuelLevel',
  OilCoolantTank: 'OilCoolantTank',
  DriveAuxiliaryDrive: 'DriveAuxiliaryDrive',
  ExhaustSystem: 'ExhaustSystem',
  SoundInsulation: 'SoundInsulation',
  EngineConnections: 'EngineConnections',
  EngineFuelTank: 'EngineFuelTank',
  AccessAndDoor: 'AccessAndDoor',
  WindowAndPaneAndMirror: 'WindowAndPaneAndMirror',
  WiperAndWasher: 'WiperAndWasher',
  DriverSeatAndRestraintSystem: 'DriverSeatAndRestraintSystem',
  HeatingAndVentilation: 'HeatingAndVentilation',
  CoverAndEmergencyExit: 'CoverAndEmergencyExit',
  ControlElement: 'ControlElement',
  PedalAndJoyStickAndLabel: 'PedalAndJoyStickAndLabel',
  ProtectiveGrille: 'ProtectiveGrille',
  AllCabinFunctions: 'AllCabinFunctions',
  BoomSection: 'BoomSection',
  TelescopicExtension: 'TelescopicExtension',
  BoomChainAndCableAndAntiFallProtection: 'BoomChainAndCableAndAntiFallProtection',
  BoomPulley: 'BoomPulley',
  BoomBearingAndBolt: 'BoomBearingAndBolt',
  BoomLock: 'BoomLock',
  WorkPlatformOrBasket: 'WorkPlatformOrBasket',
  BoomShearGuardAndArm: 'BoomShearGuardAndArm',
  LoadTesting: 'LoadTesting',
} as const

export type MachineryUVVReportItemType = (typeof MachineryUVVReportItemType)[keyof typeof MachineryUVVReportItemType]

export const MachineryUVVReportMachineryCondition = {
  Good: 'Good',
  Sufficient: 'Sufficient',
  Insufficient: 'Insufficient',
} as const

export type MachineryUVVReportMachineryCondition = (typeof MachineryUVVReportMachineryCondition)[keyof typeof MachineryUVVReportMachineryCondition]

export const MachineryUVVReportInspectionType = {
  PeriodicInspection: 'PeriodicInspection',
  ExtraordinaryInspection: 'ExtraordinaryInspection',
  Reinspection: 'Reinspection',
} as const

export type MachineryUVVReportInspectionType = (typeof MachineryUVVReportInspectionType)[keyof typeof MachineryUVVReportInspectionType]

export const MachineryUVVReminderTriggeredAction = {
  Confirm: 'Confirm',
  RejectForever: 'RejectForever',
  RemindAgainLater: 'RemindAgainLater',
} as const

export type MachineryUVVReminderTriggeredAction = (typeof MachineryUVVReminderTriggeredAction)[keyof typeof MachineryUVVReminderTriggeredAction]

export const OfferStatus = {
  draft: 'draft',
  inquiry: 'inquiry',
  invoiced: 'invoiced',
  offer: 'offer',
  order: 'order',
} as const

export type OfferStatus = (typeof OfferStatus)[keyof typeof OfferStatus]

export const CartPositionType = {
  machineryCategory: 'machineryCategory',
  machineryAccessoryCategory: 'machineryAccessoryCategory',
} as const

export type CartPositionType = (typeof CartPositionType)[keyof typeof CartPositionType]

export const OfferPositionType = {
  comment: 'comment',
  creditNote: 'creditNote',
  extraDays: 'extraDays',
  extraPosition: 'extraPosition',
  generatedByAutomation: 'generatedByAutomation',
  insurance: 'insurance',
  invoice: 'invoice',
  itemSet: 'itemSet',
  itemSetAccessory: 'itemSetAccessory',
  logisticsTask: 'logisticsTask',
  machinery: 'machinery',
  machineryAccessory: 'machineryAccessory',
  machineryAccessoryCategory: 'machineryAccessoryCategory',
  machineryCategory: 'machineryCategory',
  manualPosition: 'manualPosition',
  special: 'special',
  serviceProjectAToB: 'serviceProjectAToB',
} as const

export type OfferPositionType = (typeof OfferPositionType)[keyof typeof OfferPositionType]

export const OfferPositionGroupType = {
  GlobalTermsAndConditions: 'GlobalTermsAndConditions',
  InvoiceRelated: 'InvoiceRelated',
  MachineryAndAccessories: 'MachineryAndAccessories',
  OfferAndCustomerDefault: 'OfferAndCustomerDefault',
  SpecialPositions: 'SpecialPositions',
} as const

export type OfferPositionGroupType = (typeof OfferPositionGroupType)[keyof typeof OfferPositionGroupType]

export const OfferCancellationReason = {
  DeliveryCostTooHigh: 'DeliveryCostTooHigh',
  RentalCostTooHigh: 'RentalCostTooHigh',
  CustomerNotInterested: 'CustomerNotInterested',
  OperationPostponed: 'OperationPostponed',
  Other: 'Other',
} as const

export type OfferCancellationReason = (typeof OfferCancellationReason)[keyof typeof OfferCancellationReason]

export const OfferPositionPaymentStatus = {
  Invoiced: 'Invoiced',
  Mixed: 'Mixed',
  Open: 'Open',
} as const

export type OfferPositionPaymentStatus = (typeof OfferPositionPaymentStatus)[keyof typeof OfferPositionPaymentStatus]

export const PositionTemplateType = {
  comment: 'comment',
  extraPosition: 'extraPosition',
  insurance: 'insurance',
  logisticsTask: 'logisticsTask',
} as const

export type PositionTemplateType = (typeof PositionTemplateType)[keyof typeof PositionTemplateType]

export const LogisticsTaskTypeForDispatch = {
  Internal: 'Internal',
  ExternalInbound: 'ExternalInbound',
  ExternalOutbound: 'ExternalOutbound',
} as const

export type LogisticsTaskTypeForDispatch = (typeof LogisticsTaskTypeForDispatch)[keyof typeof LogisticsTaskTypeForDispatch]

export const LogisticsTaskType = {
  outbound: 'outbound',
  inbound: 'inbound',
  aToB: 'aToB',
  toHanselmann: 'toHanselmann',
  toWorkshop: 'toWorkshop',
  individual: 'individual',
  defect: 'defect',
} as const

export type LogisticsTaskType = (typeof LogisticsTaskType)[keyof typeof LogisticsTaskType]

export const LogisticsTaskStatus = {
  collected: 'collected',
  completed: 'completed',
  created: 'created',
  delivered: 'delivered',
  loaded: 'loaded',
  returned: 'returned',
  terminated: 'terminated',
} as const

export type LogisticsTaskStatus = (typeof LogisticsTaskStatus)[keyof typeof LogisticsTaskStatus]

export const CustomerStatus = {
  Current: 'Current',
  Potential: 'Potential',
  Unconfirmed: 'Unconfirmed',
} as const

export type CustomerStatus = (typeof CustomerStatus)[keyof typeof CustomerStatus]

export const CustomerType = {
  Dealer: 'Dealer',
  EndCustomer: 'EndCustomer',
} as const

export type CustomerType = (typeof CustomerType)[keyof typeof CustomerType]

export const CustomerLanguage = {
  DE: 'DE',
  EN: 'EN',
  FR: 'FR',
  PL: 'PL',
} as const

export type CustomerLanguage = (typeof CustomerLanguage)[keyof typeof CustomerLanguage]

export const CustomerModuleNavigationKey = {
  profile: 'profile',
  shopRent: 'shopRent',
  shopBuy: 'shopBuy',
  foreignMachinery: 'foreignMachinery',
  rentals: 'rentals',
  sales: 'sales',
  serviceProject: 'serviceProject',
  special: 'special',
  machinery: 'machinery',
  quickSale: 'quickSale',
  serviceProjectReporting: 'serviceProjectReporting',
  toMainApp: 'toMainApp',
} as const

export type CustomerModuleNavigationKey = (typeof CustomerModuleNavigationKey)[keyof typeof CustomerModuleNavigationKey]

export const ContactPersonVerificationStatus = {
  notRequested: 'notRequested',
  confirmed: 'confirmed',
  rejected: 'rejected',
  pending: 'pending',
} as const

export type ContactPersonVerificationStatus = (typeof ContactPersonVerificationStatus)[keyof typeof ContactPersonVerificationStatus]

export const UserRole = {
  noRole: 'noRole',
  guest: 'guest',
  admin: 'admin',
  projectManager: 'projectManager',
  departmentLead: 'departmentLead',
  consignee: 'consignee',
  receptionist: 'receptionist',
  rentalEmployee: 'rentalEmployee',
  salesEmployee: 'salesEmployee',
  disponent: 'disponent',
  workshopEmployee: 'workshopEmployee',
  marketingEmployee: 'marketingEmployee',
  driver: 'driver',
  bookkeeping: 'bookkeeping',
  storageLead: 'storageLead',
  storageEmployee: 'storageEmployee',
  serviceProjectEmployee: 'serviceProjectEmployee',
  serviceProjectFitter: 'serviceProjectFitter',
  freelancerSales: 'freelancerSales',
  partnerSales: 'partnerSales',
  logisticsEmployee: 'logisticsEmployee',
  externalServiceProjectContractor: 'externalServiceProjectContractor',
  externalCustomer: 'externalCustomer',
  externalServiceProjectStakeholder: 'externalServiceProjectStakeholder',
  extStorageUser: 'extStorageUser',
  customerUser: 'customerUser',
  siteManager: 'siteManager',
  specialRoleBenni: 'specialRoleBenni',
  workshopOfficeEmployee: 'workshopOfficeEmployee',
  externalWorkshopEmployee: 'externalWorkshopEmployee',
} as const

export type UserRole = (typeof UserRole)[keyof typeof UserRole]

export const DeliveryVehicleStatus = {
  Active: 'Active',
  Inactive: 'Inactive',
} as const

export type DeliveryVehicleStatus = (typeof DeliveryVehicleStatus)[keyof typeof DeliveryVehicleStatus]

export const CommentType = {
  CancelledStoragePosition: 'CancelledStoragePosition',
  ContactPerson: 'ContactPerson',
  Customer: 'Customer',
  Defect: 'Defect',
  DeliveryDate: 'DeliveryDate',
  DeliveryTime: 'DeliveryTime',
  ExternalStorageInvoicingEvent: 'ExternalStorageInvoicingEvent',
  InboundLogisticsTask: 'InboundLogisticsTask',
  InternalCostPosition: 'InternalCostPosition',
  Invoice: 'Invoice',
  ItemSet: 'ItemSet',
  LogisticsTask: 'LogisticsTask',
  Machinery: 'Machinery',
  MachineryAccessory: 'MachineryAccessory',
  Offer: 'Offer',
  OfferCustomer: 'OfferCustomer',
  OfferFeedback: 'OfferFeedback',
  OfferNote: 'OfferNote',
  OfferPreparation: 'OfferPreparation',
  OffloadedStoragePositionSet: 'OffloadedStoragePositionSet',
  OutboundLogisticsTask: 'OutboundLogisticsTask',
  ServiceProject: 'ServiceProject',
  ServiceProjectReporting: 'ServiceProjectReporting',
  SpecialPermission: 'SpecialPermission',
  StoragePosition: 'StoragePosition',
  Temporary: 'Temporary',
  Termination: 'Termination',
  UserTask: 'UserTask',
  VerifiedStoragePosition: 'VerifiedStoragePosition',
  VerifiedStoragePositionSet: 'VerifiedStoragePositionSet',
  PartnerSaleReservation: 'PartnerSaleReservation',
  CompanyVehicle: 'CompanyVehicle',
} as const

export type CommentType = (typeof CommentType)[keyof typeof CommentType]

export const CommentVisibility = {
  Private: 'Private',
  Public: 'Public',
} as const

export type CommentVisibility = (typeof CommentVisibility)[keyof typeof CommentVisibility]

export const CommentReactionType = {
  ThumbsUp: 'ThumbsUp',
  ThumbsDown: 'ThumbsDown',
  RedHeart: 'RedHeart',
} as const

export type CommentReactionType = (typeof CommentReactionType)[keyof typeof CommentReactionType]

export const InvoiceType = {
  CreditNote: 'CreditNote',
  DownPayment: 'DownPayment',
  FullPayment: 'FullPayment',
  PartialPayment: 'PartialPayment',
  ProformaPayment: 'ProformaPayment',
  Cancellation: 'Cancellation',
  CreditNoteCancellation: 'CreditNoteCancellation',
} as const

export type InvoiceType = (typeof InvoiceType)[keyof typeof InvoiceType]

export const InvoiceStatus = {
  Cancelled: 'Cancelled',
  Created: 'Created',
  NotInvoiceable: 'NotInvoiceable',
  Paid: 'Paid',
  PartiallyPaid: 'PartiallyPaid',
  Pending: 'Pending',
} as const

export type InvoiceStatus = (typeof InvoiceStatus)[keyof typeof InvoiceStatus]

export const InternalCostPositionType = {
  machinery: 'machinery',
  machineryAccessory: 'machineryAccessory',
  offer: 'offer',
} as const

export type InternalCostPositionType = (typeof InternalCostPositionType)[keyof typeof InternalCostPositionType]

export const DefectType = {
  machinery: 'machinery',
  machineryAccessory: 'machineryAccessory',
} as const

export type DefectType = (typeof DefectType)[keyof typeof DefectType]

export const ModelChangesType = {
  Offer: 'Offer',
  OfferPosition: 'OfferPosition',
} as const

export type ModelChangesType = (typeof ModelChangesType)[keyof typeof ModelChangesType]

export const CreatedByType = {
  Automation: 'Automation',
  User: 'User',
} as const

export type CreatedByType = (typeof CreatedByType)[keyof typeof CreatedByType]

export const StoragePositionStatus = {
  Created: 'Created',
  RequestedForStorage: 'RequestedForStorage',
  Offloaded: 'Offloaded',
  Stored: 'Stored',
  NotDelivered: 'NotDelivered',
  StorageApproved: 'StorageApproved',
  NotDeliveredApproved: 'NotDeliveredApproved',
  RequestedForRetrieving: 'RequestedForRetrieving',
  FullyOrdered: 'FullyOrdered',
  Retrieved: 'Retrieved',
} as const

export type StoragePositionStatus = (typeof StoragePositionStatus)[keyof typeof StoragePositionStatus]

export const StoragePositionLoadedWith = {
  Forklift: 'Forklift',
  OverheadCrane: 'OverheadCrane',
  PickAndCarryCrane: 'PickAndCarryCrane',
  Other: 'Other',
} as const

export type StoragePositionLoadedWith = (typeof StoragePositionLoadedWith)[keyof typeof StoragePositionLoadedWith]

export const InboundLogisticsTaskStatus = {
  Created: 'Created',
  RequestedForStorage: 'RequestedForStorage',
  Storing: 'Storing',
  Done: 'Done',
} as const

export type InboundLogisticsTaskStatus = (typeof InboundLogisticsTaskStatus)[keyof typeof InboundLogisticsTaskStatus]

export const PartialStoragePositionStatus = {
  RequestedForRetrieval: 'RequestedForRetrieval',
  ReadyForRetrieval: 'ReadyForRetrieval',
  RetrievalScheduled: 'RetrievalScheduled',
  Loaded: 'Loaded',
  Delivered: 'Delivered',
} as const

export type PartialStoragePositionStatus = (typeof PartialStoragePositionStatus)[keyof typeof PartialStoragePositionStatus]

export const OutboundLogisticsTaskStatus = {
  Created: 'Created',
  RequestedForRetrieval: 'RequestedForRetrieval',
  Loaded: 'Loaded',
  Done: 'Done',
} as const

export type OutboundLogisticsTaskStatus = (typeof OutboundLogisticsTaskStatus)[keyof typeof OutboundLogisticsTaskStatus]

export const ExternalStorageInvoicingEventType = {
  Picking: 'Picking',
  Repackaging: 'Repackaging',
  Ride: 'Ride',
  StorageMovement: 'StorageMovement',
  UsedStorageSpace: 'UsedStorageSpace',
  Washing: 'Washing',
  WashingRework: 'WashingRework',
} as const

export type ExternalStorageInvoicingEventType = (typeof ExternalStorageInvoicingEventType)[keyof typeof ExternalStorageInvoicingEventType]

export const FileFolderType = {
  Offer: 'Offer',
  OfferDocument: 'OfferDocument',
  OfferCustomerDocument: 'OfferCustomerDocument',
  OfferCorrespondence: 'OfferCorrespondence',
  OfferOffer: 'OfferOffer',
  OfferPicture: 'OfferPicture',
  OfferPlanAndDrawing: 'OfferPlanAndDrawing',
  OfferContractor: 'OfferContractor',
  OfferOther: 'OfferOther',
  OfferOrder: 'OfferOrder',
  OfferTermination: 'OfferTermination',
  OfferRentalDays: 'OfferRentalDays',
  OfferDefects: 'OfferDefects',
  OfferDeliveryDocument: 'OfferDeliveryDocument',
  OfferPayment: 'OfferPayment',
  OfferService: 'OfferService',
  Customer: 'Customer',
  CustomerDocument: 'CustomerDocument',
  CustomerCredit: 'CustomerCredit',
  CustomerInsuranceConfirmation: 'CustomerInsuranceConfirmation',
  CustomerSpecialAgreement: 'CustomerSpecialAgreement',
  CustomerCorrespondanceDocument: 'CustomerCorrespondanceDocument',
  CustomerExternalDocument: 'CustomerExternalDocument',
  OfferReport: 'OfferReport',
  OfferPreparation: 'OfferPreparation',
} as const

export type FileFolderType = (typeof FileFolderType)[keyof typeof FileFolderType]

export const FileVisibility = {
  Private: 'Private',
  Public: 'Public',
} as const

export type FileVisibility = (typeof FileVisibility)[keyof typeof FileVisibility]

export const ServiceProjectTimeTrackingStatus = {
  Done: 'Done',
  Open: 'Open',
  Cancelled: 'Cancelled',
} as const

export type ServiceProjectTimeTrackingStatus = (typeof ServiceProjectTimeTrackingStatus)[keyof typeof ServiceProjectTimeTrackingStatus]

export const ServiceProjectTimeTrackingType = {
  ServiceEmployee: 'ServiceEmployee',
  OtherPersons: 'OtherPersons',
} as const

export type ServiceProjectTimeTrackingType = (typeof ServiceProjectTimeTrackingType)[keyof typeof ServiceProjectTimeTrackingType]

export const ServiceProjectTravelCancellationReason = {
  HotelStay: 'HotelStay',
  InternalProject: 'InternalProject',
} as const

export type ServiceProjectTravelCancellationReason = (typeof ServiceProjectTravelCancellationReason)[keyof typeof ServiceProjectTravelCancellationReason]

export const AccessCodeScope = {
  OfferRental: 'OfferRental',
} as const

export type AccessCodeScope = (typeof AccessCodeScope)[keyof typeof AccessCodeScope]

export const ExternalSalesMarketplaceId = {
  MachineryZone: 'MachineryZone',
  ForkliftInternational: 'ForkliftInternational',
  Supralift: 'Supralift',
  Maschinensucher: 'Maschinensucher',
  Mascus: 'Mascus',
} as const

export type ExternalSalesMarketplaceId = (typeof ExternalSalesMarketplaceId)[keyof typeof ExternalSalesMarketplaceId]

export const ExternalSalesMarketplaceExportResult = {
  Success: 'Success',
  PartialSuccess: 'PartialSuccess',
  Failure: 'Failure',
} as const

export type ExternalSalesMarketplaceExportResult = (typeof ExternalSalesMarketplaceExportResult)[keyof typeof ExternalSalesMarketplaceExportResult]

export const RentalPriceModifierUnit = {
  Absolute: 'Absolute',
  Percent: 'Percent',
} as const

export type RentalPriceModifierUnit = (typeof RentalPriceModifierUnit)[keyof typeof RentalPriceModifierUnit]

export const RentalPriceModifierConditionType = {
  Days: 'Days',
  CustomerType: 'CustomerType',
  CustomerTypeAndDays: 'CustomerTypeAndDays',
  SpecificCustomer: 'SpecificCustomer',
} as const

export type RentalPriceModifierConditionType = (typeof RentalPriceModifierConditionType)[keyof typeof RentalPriceModifierConditionType]

export const RentalPriceModifierCustomerType = {
  Dealer: 'Dealer',
  DealerAndPartnerLift: 'DealerAndPartnerLift',
  DealerAndSystemLift: 'DealerAndSystemLift',
  EndCustomer: 'EndCustomer',
} as const

export type RentalPriceModifierCustomerType = (typeof RentalPriceModifierCustomerType)[keyof typeof RentalPriceModifierCustomerType]

export const CompanyVehicleDrive = {
  Diesel: 'Diesel',
  Benzine: 'Benzine',
  Electric: 'Electric',
} as const

export type CompanyVehicleDrive = (typeof CompanyVehicleDrive)[keyof typeof CompanyVehicleDrive]

export const CompanyVehicleTire = {
  Winter: 'Winter',
  Summer: 'Summer',
  AllWeather: 'AllWeather',
} as const

export type CompanyVehicleTire = (typeof CompanyVehicleTire)[keyof typeof CompanyVehicleTire]

export const CompanyVehicleRentalCondition = {
  Clean: 'Clean',
  Unclean: 'Unclean',
  Defect: 'Defect',
} as const

export type CompanyVehicleRentalCondition = (typeof CompanyVehicleRentalCondition)[keyof typeof CompanyVehicleRentalCondition]

export const CompanyVehicleRentalTankFilling = {
  Full: 'Full',
  HalfFull: 'HalfFull',
  Empty: 'Empty',
} as const

export type CompanyVehicleRentalTankFilling = (typeof CompanyVehicleRentalTankFilling)[keyof typeof CompanyVehicleRentalTankFilling]

export const SendingStatus = {
  Success: 'Success',
  Failed: 'Failed',
  Sending: 'Sending',
} as const

export type SendingStatus = (typeof SendingStatus)[keyof typeof SendingStatus]
